import {Component, OnInit} from '@angular/core';
import {UIRouter} from '@uirouter/angular';
import {EnumerationService} from '../enumeration/enumeration.service';
import {Customer} from './customer.model';
import {CustomerService} from './customer.service';
import {CombiFormComponent} from '../shared/combi-form.component';
import {RoutePrefix} from '../shared/route-prefix';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-customer-form',
  templateUrl: './customer-form.component.html'
})
export class CustomerFormComponent extends CombiFormComponent implements OnInit {
  public customer: Customer = new Customer();
  public formTitle: string;
  public blockClasses: string;
  public formClass: string;
  public formLabelClass: string;
  public formControlClass: string;
  public formContainerClass: string;
  public contactRoutePrefix: RoutePrefix;
  public countries: string[] = [];

  constructor(
    protected router: UIRouter,
    protected customerService: CustomerService,
    protected enumService: EnumerationService,
    private translate: TranslateService
  ) {
    super(router);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    this.enumService.get('country').subscribe((countries: string[]) => {
      this.countries = countries;
    });

    switch(this.formMode) {
      case this.FormMode.ADD : {
        this.translate.get('customer.form.add.blockTitle').subscribe((translation) => {
          this.formTitle = translation;
        });
      } break;

      case this.FormMode.UPDATE : {
        this.translate.get('customer.form.update.blockTitle').subscribe((translation) => {
          this.formTitle = translation;
        });

        this.contactRoutePrefix = {entity: Customer.name, entityId: this.router.stateService.params.id};
        this.customerService.get(this.router.stateService.params.id).subscribe((customer) => {
          this.customer = customer;
        });
      } break;
    }
  }

  public save() {
    switch(this.formMode) {
      case this.FormMode.ADD : {
        this.customerService.add(this.customer).subscribe((response) => {
          const customer = new Customer();
          customer.fromResponse(response);
          this.router.stateService.go('customer.edit', {id: customer.id}, {reload: true});
        });
      } break;

      case this.FormMode.UPDATE : {
        this.customerService.update(this.customer).subscribe((response) => {
          this.router.stateService.go('customer', null, {reload: true});
        });
      } break;
    }
  }


}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/customer/customer-form.component.ts